"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var currency_1 = require("../service/currency");
var urlRoute_1 = require("../service/urlRoute");
var constants_1 = require("./constants");
var BASE_URL = constants_1.default.BASE_URL, AUD = constants_1.default.AUD, FINANCE_CALCULATOR_WIDGET_BASE_PATH = constants_1.default.FINANCE_CALCULATOR_WIDGET_BASE_PATH;
var fcConfig = {
    instanceId: 1,
    currency: currency_1.currency.getCurrency(AUD),
    backendUrl: BASE_URL,
    widgetUrl: process.env.REACT_APP_WIDGETS_BASE_PATH
        ? urlRoute_1.default.joinUrl(process.env.REACT_APP_WIDGETS_BASE_PATH + FINANCE_CALCULATOR_WIDGET_BASE_PATH)
        : process.env.REACT_APP_FC_WIDGET_PATH,
    paths: {
        chunkPath: process.env.REACT_APP_WIDGETS_BASE_PATH ? '/modules.fc.chunk.js' : '/legacy-widget.fc.chunk.js',
        widgetPath: '/fc.js',
    },
    dxpWidgetUrl: process.env.REACT_APP_DXP_WIDGETS_BASE_PATH +
        (process.env.REACT_APP_COUNTRY + "/" + process.env.REACT_APP_BRAND_CODE + "/widgets/finance-calculator/dist/finance-calculator.esm.js"),
};
exports.default = fcConfig;
